const TeamManagementView = () => import("../presentation/views/TeamManagementView.vue");
// PO ruling B4 (OP-7996, 2026-09-28): the screen belongs to the RC/RCA and the AA — only
// OpsolDivisionManager and OpsolReceptionAgent carry opsol.absences (BFF
// PermissionHelper.AbsencesCapability). OPAGD's unavailability policy also admits the social
// worker; this gate is UI scoping, narrower on purpose, not a security boundary.
const TEAM_META = {
    requiresAuth: true,
    titleKey: "team.pageTitle",
    requiresCapability: "opsol.absences",
};
export const teamRoutes = [
    {
        path: "/team",
        name: "TeamManagement",
        component: TeamManagementView,
        meta: { ...TEAM_META },
    },
];
// CONSTRAINT: nothing renders module navigation items today; the enforced gate is teamEntry in
// MainSidebar.vue. Wire this list somewhere and it must carry the capability too.
export const teamNavigationItems = [
    { labelKey: "sidebar.team", path: "/team", meta: { requiresAuth: true } },
];
